export default "<ng-template #tabContent>\r\n  <div class=\"tab-content\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</ng-template>\r\n";